import { useEffect, useState } from "react";

import { ErrorPage, PageLayout } from "@ezmid/components-library";
import { useTranslation } from "react-i18next";
import { useNavigate, useParams } from "react-router";

import { useGetUserByIdQuery } from "../../../api/user.generated";
import {
  useActivateUserByIdMutation,
  useDeactivateUserByIdMutation,
} from "../../../api/users.generated";
import { ParamId } from "../../../enums/types";
import { makeRoute } from "../../../hooks/route";
import { AllRoutes } from "../../route/Route";
import { UsersDetailPageContent } from "../organisms/UsersDetailPageContent";

export function UserDetailPage() {
  const { id }: ParamId = useParams();
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { isFetching, currentData, isError, isSuccess } = useGetUserByIdQuery(
    {
      id: id ?? "",
    },
    {
      refetchOnMountOrArgChange: true,
    }
  );
  const [isUserDeactivated, setIsUserDeactivated] = useState<boolean>(
    currentData?.status === "us-deactivated"
  );
  const [activateUser] = useActivateUserByIdMutation();
  const [deactivateUser] = useDeactivateUserByIdMutation();

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    event.target.checked
      ? deactivateUser({ id: id || "" })
      : activateUser({ id: id || "" });
    setIsUserDeactivated(event.target.checked);
  };

  useEffect(() => {
    setIsUserDeactivated(currentData?.status === "us-deactivated");
  }, [currentData]);

  return isError ? (
    <ErrorPage
      errorMessageText={t("app.page.error.page.not.found")}
      messageForUser={t("app.page.error.defaultMessage")}
      hasGoBackButton
      buttonText={t("app.goToDasboard")}
      onButtonClick={() => navigate(makeRoute(AllRoutes.DASHBOARD))}
    />
  ) : (
    <PageLayout title={currentData?.name || ""}>
      <UsersDetailPageContent
        isSuccess={isSuccess}
        isError={isError}
        currentData={currentData}
        isFetching={isFetching}
        id={id || ""}
        onUserStatusChange={handleChange}
        isUserDeactivated={isUserDeactivated}
      />
    </PageLayout>
  );
}
